import styled from 'styled-components';

export const StyledText = styled.text`
  text-transform: uppercase;
  ${({ theme }) => theme.new.typography.p6};
  fill: ${({ theme }) => theme.new.colors.N600};
`;
